<script>
	import { onDestroy } from 'svelte';
	import { dataStore } from '../lib/store';
	import Pagination from './Pagination.svelte';
	import Grid from './Grid.svelte';
	import Card from './Card.svelte';
	import Loader from './General/Loader.svelte';
	import { performSearch } from '../lib/api';
	import { translate } from '../lib/translate';

	let lastPage = 1;

	const unsubscribe = dataStore.subscribe(data => {
		// Detect change in store -> page
		if (lastPage !== data.page) {
			performSearch();
		}
		lastPage = data.page;
	});

	onDestroy(unsubscribe);
</script>

<div class="container">
	<div class="results-header">
		{#if $dataStore.loading}
			<div class="loading">
				<Loader />
				<h2>{translate('Wird geladen')}</h2>
			</div>
		{:else}
			<h2>{$dataStore.totalCount} {translate('vehicles_found')}</h2>
		{/if}
		<div class="show-for-large">
			<Pagination loading={$dataStore.loading} />
		</div>
	</div>
	<div class="results">
		<Grid columns={[1, 2, 3]} gap={[30, 35]}>
			{#each $dataStore.results as result}
				<Card
					id={result.id}
					image={result.image}
					title={result.title}
					subTitle={result.extraInformation}
					refId={result.truckId}
					price={result.salesPrice}
					location={result.city}
					specs={result.summary?.map(({ value, unit }) => value + (unit ?? ''))}
				/>
			{/each}
		</Grid>
	</div>
	<div class="pagination-bottom">
		<Pagination loading={$dataStore.loading} />
	</div>
</div>

<style type="text/scss" lang="scss">
	.container {
		@media (max-width: 1199px) {
			padding: 0px;
		}
	}

	.loading {
		display: flex;
		align-items: center;
		h2 {
			margin-left: 15px;
		}
	}

	.results-header {
		width: 100%;
		height: 137px;
		display: flex;
		align-items: center;
		justify-content: space-between;
		h2 {
			font-weight: 700;
			font-size: 28px;
			color: var(--c-primary);
		}
	}

	.pagination-bottom {
		display: flex;
		justify-content: flex-end;
		margin: 55px 0 52px;
		
		@media (max-width: 559px) {
			justify-content: center;
		}
	}
</style>
